/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";

// @emotion/css
import { css } from "@emotion/css";

// @mui/material
import { Box, Button, Link, Typography, useTheme } from "@mui/material";

// images
import noPic from "../../../../assets/images/noPic.jpg";

//icons
import ChatIcon from "@mui/icons-material/Chat";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addItemsToLocalStorage } from "../../../../utils/functions";
import { dislikeNews as dislike, likeNews as like, removeHtmlTags } from "../../../../actions";
import SitoImage from "sito-image";
import {
    dislikeNewsAction as dislikeAction,
    likeNewsAction as likeAction,
} from "../../../../redux/slices/userSlice";
import CountLikeAndDislike from "../../../LikeAndDislike/CountLikeAndDislike";
import { useMode } from "../../../../context/ModeProvider";

const HeadlineNewsCard = (props) => {
    const theme = useTheme();
    const { modeState } = useMode();
    const {
        item,
        textTitle = true,
        refreshData,
        positionPressMedia1 = true,
        positionPressMedia2 = true,
        logo = "",
        source = "",
        options = {
            height: { xs: "236px", sm: "266px", lg: "266px", xl: "300px" },
        },
        colSpan = "",
        titleSx = {},
    } = props;

    const news = useSelector((state) => state.news);

    const dispatch = useDispatch();

    const title = item?.title;
    const image = item?.image;
    const link = item?.link;
    const tags = item?.tags;
    const [isLike, setIsLike] = useState(false);
    const [isDisLike, setIsDisLike] = useState(false);
    const [likes, setLikes] = useState(0);
    const [dislikes, setDislikes] = useState(0);
    const navigate = useNavigate();
    const userToken = sessionStorage.getItem("token");
    const user = useSelector((state) => state.user);

    useEffect(() => {
        setIsLike(news[item.id] == "L");
        setIsDisLike(news[item.id] == "D");

        if (item.likes) setLikes(parseInt(item.likes));
        if (item.dislikes) setDislikes(parseInt(item.dislikes));
    }, [item, news]);

    const gotoForum = (id) => {
        navigate(`/forum/${id}`);
    };

    const handleLike = () => {
        setIsLike(!isLike);
        setIsDisLike(false);
        like(item.id, news[item.id] == "L")
            .then(() => {
                if (news[item.id] == "L") setLikes(likes - 1);
                if (!news[item.id]) setLikes(likes + 1);
                if (news[item.id] == "D") {
                    setLikes(likes + 1);
                    setDislikes(dislikes - 1);
                    dislike(item.id, true)
                        .then(() => {})
                        .catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err));
        dispatch(likeAction({ id: item.id }));
    };

    const handleDisLike = () => {
        setIsLike(false);
        setIsDisLike(!isDisLike);
        dislike(item.id, news[item.id] == "D")
            .then(() => {
                if (news[item.id] == "D") setDislikes(dislikes - 1);
                if (!news[item.id]) setDislikes(dislikes + 1);
                if (news[item.id] == "L") {
                    setDislikes(dislikes + 1);
                    setLikes(likes - 1);
                    like(item.id, true)
                        .then(() => {})
                        .catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err));
        dispatch(dislikeAction({ id: item.id }));
    };

    const printLike = () => {
        setIsLike(news[item.id] == "L");
        setIsDisLike(news[item.id] == "D");
    };

    const printDisLike = () => {
        setIsLike(news[item.id] == "L");
        setIsDisLike(news[item.id] == "D");
    };

    const handleAddTagsOnClick = (e) => {
        addItemsToLocalStorage("newsTags", tags);
    };
    const randomGradient = `gradient-${Math.floor(Math.random() * 10) + 1}`;

    return (
        <Box
            onClick={handleAddTagsOnClick}
            sx={{
                position: "relative",
                marginTop: "10px",
                marginRight: "10px",
                gridColumn: colSpan,
            }}
        >
            <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className={css({
                    color: "inherit",
                    textDecoration: "none",
                })}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: options.height,
                        borderRadius: "5px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <SitoImage
                        className={randomGradient}
                        sx={{
                            borderRadius: "5px",
                            objectFit: "fill",
                        }}
                        src={image}
                        alt=""
                    />
                    {positionPressMedia1 === true && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                pb: "5px",
                                position: "absolute",
                                top: "0",
                                padding: "10px",
                            }}
                        >
                            {logo && (
                                <img
                                    src={logo}
                                    alt=""
                                    style={{
                                        width: "1rem",
                                        height: "1rem",
                                        borderRadius: "2px",
                                    }}
                                />
                            )}

                            <Typography
                                sx={{
                                    pl: "5px",
                                    color: theme.noticeCard.text,
                                    background:
                                        modeState.mode === "dark"
                                            ? "linear-gradient(to right, #FFEOB2, #FFF3EO)"
                                            : "linear-gradient(to right, #FFCDD2, #FFEBEE)",

                                    WebkitBackgroundClip: "text",
                                    textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
                                }}
                            >
                                {source}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </a>
            <Box
                sx={{
                    padding: "5px",
                    height: {
                        xs: "calc(100% - 150px)",
                        sm: "calc(100% - 200px)",
                        lg: "calc(100% - 205px)",
                        xl: "calc(100% - 210px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ width: "100%" }}>
                    {positionPressMedia2 === true && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                color: "",
                                pb: "5px",
                            }}
                        >
                            {logo && (
                                <img
                                    src={logo}
                                    alt=""
                                    style={{
                                        width: "1rem",
                                        height: "1rem",
                                        borderRadius: "2px",
                                    }}
                                />
                            )}

                            <Typography
                                sx={{
                                    pl: "5px",
                                }}
                            >
                                {source}
                            </Typography>
                        </Box>
                    )}
                    <a
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className={css({
                            color: "inherit",
                            textDecoration: "none",
                        })}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontSize: "18px",
                                fontWeight: "600",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                display: "-webkit-box",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                ...titleSx,
                            }}
                        >
                            {textTitle === true && removeHtmlTags(title)}
                        </Typography>
                    </a>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "initial",
                        }}
                    >
                        <Button
                            onClick={handleLike}
                            sx={{
                                display: "flex",
                                color: theme.palette.primary.main,
                                alignItems: "center",
                            }}
                        >
                            {!isLike ? (
                                <ThumbUpOffAltIcon
                                    sx={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "5px",
                                        cursor: "pointer",
                                    }}
                                />
                            ) : (
                                <ThumbUpAltIcon
                                    sx={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "5px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            <CountLikeAndDislike count={likes} />
                        </Button>
                        <Button
                            onClick={handleDisLike}
                            sx={{
                                display: "flex",
                                color: theme.palette.primary.main,
                                alignItems: "center",
                            }}
                        >
                            {!isDisLike ? (
                                <ThumbDownOffAltIcon
                                    sx={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "5px",
                                        cursor: "pointer",
                                    }}
                                />
                            ) : (
                                <ThumbDownAltIcon
                                    sx={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "5px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            <CountLikeAndDislike count={dislikes} />
                        </Button>
                        {/*item?.debate ? (
                            <Button
                                onClick={() => gotoForum(item?.debate?.id)}
                                sx={{
                                    display: "flex",
                                    color: theme.palette.primary.main,
                                    alignItems: "center",
                                }}
                            >
                                <ChatIcon sx={{ width: "18px", height: "18px", marginRight: "5px" }} />
                                <Typography sx={{ color: "gray", fontSize: "13px" }}>
                                    {item?.debate?.comments}
                                </Typography>
                            </Button>
                        ) : (
                            " "
                        )*/}
                        <Link
                            href={`/comunidad/noticia/${item.id}`}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "row",
                            }}
                        >
                            <CommentRoundedIcon fontSize="small" />
                        </Link>
                    </Box>
                    {/*<Typography
                        sx={{
                            fontSize: "14px",
                            pt: "0px",
                            transition: "max-height 400ms ease",
                            overflow: "hidden",
                            width: "100%",
                            lineHeight: "1.57",
                            "& img": { width: "100%" },
                        }}
                        variant="subtitle2"
                        //color="#FFF"
                    >
                        {content?.length !== 0
                            ? removeHtmlTags(content)?.trim().slice(0, 130)
                            : "No content"}
                    </Typography>*/}
                </Box>
                {/*<Box sx={{ width: "100%" }}>
                    <Link
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className={css({
                            color: "inherit",
                            textDecoration: "none",
                        })}
                    >
                        Leer más...
                    </Link>
                </Box>*/}
            </Box>
        </Box>
    );
};

export default HeadlineNewsCard;
